import {
  initWaterMarker as init,
  baseConfig,
} from '@nio-wad/workbench-watermark';

export function initWaterMarker(text: string | string[]) {
  const options = {
    width: 120,
    height: 64,
    gapX: 100,
    gapY: 100,
    fontSize: 16,
  };
  Object.assign(baseConfig, options);
  init(text as string);
}
